(() => {
  const MAX_MOBILE_WIDTH = 749;

  function initBar(bar) {
    if (!bar || bar.dataset.wg03Initialized === 'true') return;

    const productInfo = bar.closest('product-info') || document.querySelector('product-info');
    if (!productInfo) return;

    const nativeButton = productInfo.querySelector('[id^="ProductSubmitButton-"]');
    const proxyButton = bar.querySelector('[data-wg03-mobile-purchase-button]');
    if (!nativeButton || !proxyButton) return;

    bar.dataset.wg03Initialized = 'true';
    const media = window.matchMedia(`(max-width: ${MAX_MOBILE_WIDTH}px)`);
    let nativeButtonVisible = false;
    let temporarilyHidden = false;

    const cartOverlayOpen = () =>
      Boolean(document.querySelector('cart-drawer.active, cart-notification.active'));

    const syncButton = () => {
      const disabled =
        nativeButton.disabled ||
        nativeButton.getAttribute('aria-disabled') === 'true';
      proxyButton.disabled = disabled;
      proxyButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');

      const nativeLabel = nativeButton.querySelector('span')?.textContent?.trim();
      if (nativeLabel) {
        proxyButton.textContent = nativeLabel;
        proxyButton.setAttribute('aria-label', nativeLabel);
      }
    };

    const syncVisibility = () => {
      const shouldShow =
        media.matches &&
        !nativeButtonVisible &&
        !temporarilyHidden &&
        !cartOverlayOpen() &&
        !proxyButton.disabled;
      bar.hidden = !shouldShow;
    };

    const intersection = new IntersectionObserver(
      ([entry]) => {
        nativeButtonVisible = Boolean(entry?.isIntersecting);
        syncVisibility();
      },
      { threshold: 0.15 }
    );
    intersection.observe(nativeButton);

    const nativeMutation = new MutationObserver(() => {
      syncButton();
      syncVisibility();
    });
    nativeMutation.observe(nativeButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    const overlayMutation = new MutationObserver(syncVisibility);
    overlayMutation.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'open'],
    });

    const onMediaChange = () => syncVisibility();
    if (media.addEventListener) {
      media.addEventListener('change', onMediaChange);
    } else {
      media.addListener(onMediaChange);
    }

    proxyButton.addEventListener('click', () => {
      syncButton();
      if (proxyButton.disabled) return;

      temporarilyHidden = true;
      bar.hidden = true;
      nativeButton.click();

      window.setTimeout(() => {
        temporarilyHidden = false;
        syncButton();
        syncVisibility();
      }, 1800);
    });

    syncButton();
    syncVisibility();
  }

  const boot = () => {
    document
      .querySelectorAll('[data-wg03-mobile-purchase-bar]')
      .forEach(initBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
